module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ef-Fb-Ga.285d285a.png";